import { render } from "./base.vue?vue&type=template&id=46f4d034&scoped=true"
import script from "./base.vue?vue&type=script&lang=ts"
export * from "./base.vue?vue&type=script&lang=ts"

import "./base.vue?vue&type=style&index=0&id=46f4d034&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-46f4d034"

export default script